'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hammerIsomorphic = require('./helpers/hammer.isomorphic.js');

var _hammerIsomorphic2 = _interopRequireDefault(_hammerIsomorphic);

var _helperEvents = require('@rnb/helper-events');

var _uiCarousel = require('./ui-carousel.less');

var _uiCarousel2 = _interopRequireDefault(_uiCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Carousel = function (_Component) {
    _inherits(Carousel, _Component);

    function Carousel(props) {
        _classCallCheck(this, Carousel);

        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.timeOutId = null;
        _this.isScrolling = null;
        _this.touchstartx = 0;
        _this.touchmovex = 0;
        _this.isInitialMove = false;
        _this.longPan = null;
        _this._isMounted = false;
        _this.ref_list_inner_wrapper = _react2.default.createRef();
        _this.ref_list = _react2.default.createRef();

        _this.state = {
            currentInterval: {},
            page: 1,
            lastPage: 1,
            listWidth: 0,
            listItems: 0,
            itemWidth: 0,
            listIndention: 0,
            listItemSpacing: 0,
            counter: 0,
            adjustCounterBy: 0
        };
        return _this;
    }

    /*
        config: Array of objects, object data is used to dimension list items for set break points
        setting value of 0 to listIndention will NOT offset the list to show a hint of more available items
    */

    _createClass(Carousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.onResizeWindowWidthSubscription = _helperEvents.EventAggregator.subscribe("onResizeWindowWidth", function (windowWidth) {
                return _this2.windowWidthChanged(windowWidth);
            });
            this.onScrollSubscription = _helperEvents.EventAggregator.subscribe("onScroll", function () {
                return _this2.onScroll();
            });

            setTimeout(function () {
                _this2.hammerList = new _hammerIsomorphic2.default(_this2.ref_list.current);
                _this2.initTouchInteraction();
                _this2._isMounted = true;
                _this2.update();
                _helperEvents.EventAggregator.initListeners();
            }, 25);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.onResizeWindowWidthSubscription.remove();
            this.onScrollSubscription.remove();
            this.hammerList.off();
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var _this3 = this;

            this.isScrolling = true;
            clearTimeout(this.timeOutId);
            this.timeOutId = setTimeout(function () {
                return _this3.isScrolling = false;
            }, 25);
        }
    }, {
        key: 'windowWidthChanged',
        value: function windowWidthChanged(windowWidth) {
            this.windowWidth = windowWidth;
            this.update();
        }
    }, {
        key: 'initTouchInteraction',
        value: function initTouchInteraction() {
            var _this4 = this;

            this.hammerList.on('panstart', function (e) {
                return _this4.onPanStart(e);
            });
            this.hammerList.on('panmove', function (e) {
                return _this4.onPanMove(e);
            });
            this.hammerList.on('panend', function (e) {
                return _this4.onPanEnd(e);
            });
            this.hammerList.get("pan").set({ direction: _hammerIsomorphic2.default.DIRECTION_HORIZONTAL, threshold: 10 });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this5 = this;

            var navigateToPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var noTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var page = navigateToPage ? navigateToPage : this.getPage();

            if (this._isMounted) {
                this.setState({
                    currentInterval: this.getCurrentInterval(),
                    page: page,
                    lastPage: this.getLastPage(),
                    listWidth: this.getListWidth(),
                    listItems: this.getListItems(),
                    itemWidth: this.getItemWidth(),
                    listIndention: this.getListIndention(),
                    listItemSpacing: this.getListItemSpacing(),
                    counter: this.getCounter(page),
                    adjustCounterBy: this.getAdjustCounterBy(page)
                }, function () {
                    return _this5.slide(noTransition);
                });
            }
        }
    }, {
        key: 'getCurrentInterval',
        value: function getCurrentInterval() {
            var _this6 = this;

            return this.props.config.find(function (interval) {
                return _this6.windowWidth >= interval.start && _this6.windowWidth <= interval.end;
            });
        }
    }, {
        key: 'getPage',
        value: function getPage() {
            var lastPage = this.getLastPage();
            var currentInterval = this.getCurrentInterval();

            lastPage === 1 ? this.hammerList.set({ enable: false }) : this.hammerList.set({ enable: true });

            return Math.floor(this.state.counter / currentInterval.itemsPerPage) + 1 >= lastPage ? lastPage : Math.floor(this.state.counter / currentInterval.itemsPerPage) + 1;
        }
    }, {
        key: 'getLastPage',
        value: function getLastPage() {
            var currentInterval = this.getCurrentInterval();
            return this.props.listItems ? Math.ceil(this.props.listItems.length / currentInterval.itemsPerPage) : Math.ceil(this.getListItems().length / currentInterval.itemsPerPage);
        }
    }, {
        key: 'getListWidth',
        value: function getListWidth() {
            var currentInterval = this.getCurrentInterval();
            return currentInterval.itemsPerPage * this.getItemWidth();
        }
    }, {
        key: 'getListItems',
        value: function getListItems() {
            return this.ref_list.current.children;
        }
    }, {
        key: 'getItemWidth',
        value: function getItemWidth() {
            var currentInterval = this.getCurrentInterval();
            var listIndention = currentInterval.listIndention;
            var listItemSpacing = currentInterval.listItemSpacing;
            var itemsPerPage = currentInterval.itemsPerPage;
            var listWrapperWidth = this.ref_list_inner_wrapper.current.clientWidth;

            return listIndention > 0 ? (listWrapperWidth - listIndention) / itemsPerPage - listItemSpacing / itemsPerPage : (listWrapperWidth + listItemSpacing) / itemsPerPage;
        }
    }, {
        key: 'getListItemSpacing',
        value: function getListItemSpacing() {
            var currentInterval = this.getCurrentInterval();
            return currentInterval.listItemSpacing;
        }
    }, {
        key: 'getListIndention',
        value: function getListIndention() {
            var currentInterval = this.getCurrentInterval();
            return currentInterval.listIndention;
        }
    }, {
        key: 'getCounter',
        value: function getCounter(page) {
            var lastPage = this.getLastPage();
            var currentInterval = this.getCurrentInterval();

            if (page === 1) {
                return 0;
            } else if (page === lastPage) {
                return this.getListItems().length - currentInterval.itemsPerPage;
            } else {
                return (page - 1) * currentInterval.itemsPerPage;
            }
        }
    }, {
        key: 'getAdjustCounterBy',
        value: function getAdjustCounterBy(page) {
            var lastPage = this.getLastPage();
            var currentInterval = this.getCurrentInterval();

            if (page === 1) {
                return 0;
            } else if (page === lastPage) {
                return this.props.listItems.length % currentInterval.itemsPerPage ? currentInterval.itemsPerPage - this.props.listItems.length % currentInterval.itemsPerPage : 0;
            } else {
                return this.state.adjustCounterBy ? this.state.adjustCounterBy : 0;
            }
        }
    }, {
        key: 'onPanStart',
        value: function onPanStart(e) {
            var _this7 = this;

            this.isInitialMove = true;
            this.longPan = false;
            setTimeout(function () {
                return _this7.longPan = true;
            }, 250);
            this.touchstartx = e.deltaX;

            this.setTransition("");
        }
    }, {
        key: 'onPanMove',
        value: function onPanMove(e) {
            if (this.isScrolling) {
                return;
            }
            if (this.isInitialMove) {
                this.touchstartx = this.touchstartx + (e.direction === 2 ? 15 : e.direction === 4 ? -15 : 0);
                this.isInitialMove = false;
            }

            this.touchmovex = e.deltaX;
            this.movex = this.touchstartx + this.touchmovex - (this.state.page - 1) * this.state.listWidth + this.state.adjustCounterBy * this.state.itemWidth;
            this.setTransform3d(this.movex);
        }
    }, {
        key: 'onPanEnd',
        value: function onPanEnd(e) {
            if (this.isSwipeBigEnough(this.touchstartx, this.touchmovex, this.state.listWidth) || this.longPan === false) {
                if (this.isValidPanNext(e, this.state.page, this.state.lastPage)) {
                    this.onNavigateNext();
                } else if (this.isValidPanPrevious(e, this.state.page)) {
                    this.onNavigatePrevious();
                } else {
                    this.slide();
                }
            } else {
                this.slide();
            }
        }
    }, {
        key: 'setTransform3d',
        value: function setTransform3d() {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var transform = 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)';
            this.ref_list.current.style.WebkitTransform = transform;
            this.ref_list.current.style.MozTransform = transform;
            this.ref_list.current.style.OTransform = transform;
            this.ref_list.current.style.msTransform = transform;
            this.ref_list.current.style.transform = transform;
        }
    }, {
        key: 'setTransition',
        value: function setTransition(transition) {
            this.ref_list.current.style.WebkitTransition = transition;
            this.ref_list.current.style.MozTransition = transition;
            this.ref_list.current.style.OTransition = transition;
            this.ref_list.current.style.msTransition = transition;
            this.ref_list.current.style.transition = transition;
        }
    }, {
        key: 'isSwipeBigEnough',
        value: function isSwipeBigEnough() {
            var divideBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;

            return Math.abs(this.touchstartx + this.touchmovex) > this.state.listWidth / divideBy;
        }
    }, {
        key: 'isValidPanNext',
        value: function isValidPanNext(e) {
            return e.direction === 2 && this.state.page < this.state.lastPage;
        }
    }, {
        key: 'isValidPanPrevious',
        value: function isValidPanPrevious(e) {
            return e.direction === 4 && this.state.page - 1 > 0;
        }
    }, {
        key: 'slide',
        value: function slide() {
            var noTransition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.setTransition(noTransition ? "" : this.props.customTransition);
            this.state.lastPage === 1 ? this.setTransform3d(0, 0, 0) : this.setTransform3d(-(this.state.counter * this.state.itemWidth));

            if (typeof this.props.pageUpdate === 'function') {
                this.props.pageUpdate(this.state.page, this.state.lastPage);
            }
        }
    }, {
        key: 'onNavigateNext',
        value: function onNavigateNext() {
            var _this8 = this;

            if (this.state.page < this.state.lastPage) {
                this.setState({
                    page: this.state.page + 1,
                    counter: this.getCounter(this.state.page + 1),
                    adjustCounterBy: this.getAdjustCounterBy(this.state.page + 1)
                }, function () {
                    return _this8.slide();
                });
            }
        }
    }, {
        key: 'onNavigatePrevious',
        value: function onNavigatePrevious() {
            var _this9 = this;

            if (this.state.page > 1) {
                this.setState({
                    page: this.state.page - 1,
                    counter: this.getCounter(this.state.page - 1),
                    adjustCounterBy: this.getAdjustCounterBy(this.state.page - 1)
                }, function () {
                    return _this9.slide();
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this10 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { ref: this.ref_list_inner_wrapper, className: "ui-carousel__list-wrapper" },
                    _react2.default.createElement(
                        'ul',
                        { ref: this.ref_list,
                            style: {
                                width: this.state.listWidth + "px",
                                left: this.state.listIndention + "px",
                                marginLeft: -this.state.listItemSpacing + "px"
                            },
                            className: "ui-carousel__list" },
                        this.props.listItems.map(function (item, i) {
                            return _react2.default.createElement(
                                'li',
                                { style: {
                                        width: _this10.state.itemWidth + "px",
                                        paddingLeft: _this10.state.listItemSpacing + "px"
                                    },
                                    key: i,
                                    className: 'ui-carousel__list-item' },
                                item
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Carousel;
}(_react.Component);

Carousel.defaultProps = {
    listItems: [],
    pageUpdate: null, /* call back function to return 'page' and 'last page' */
    customTransition: "transform 300ms ease-out",
    config: [{
        start: 0,
        end: 574,
        itemsPerPage: 1,
        listIndention: 16,
        listItemSpacing: 16
    }, {
        start: 575,
        end: 1023,
        itemsPerPage: 2,
        listIndention: 16,
        listItemSpacing: 16
    }, {
        start: 1024,
        end: 9999,
        itemsPerPage: 3,
        listIndention: 0,
        listItemSpacing: 16
    }]
};
exports.default = Carousel;